import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { BeApiOrderItem } from '../models/beapi.model';
import { Parcel } from '../models/parcel.model';

@Injectable({ providedIn: 'root' })
export class BeApiService {
  private beApiUrl = '/tools/beapi';
  constructor(private http: HttpClient) {}

  fillBeApiStatus(parcels: Parcel[], fillBeApiStatus: boolean) {
    //	TODO handle errors
    if (!parcels || parcels.length === 0) {
      return;
    }

    const parcelIndex = new Map<number, Parcel>();
    for (const parcel of parcels) {
      parcelIndex.set(parcel.id, parcel);
    }

    if (fillBeApiStatus) {
      this.getBatchOrderItems(parcels.map((x) => x.id)).subscribe((x) => {
        for (const baOI of x) {
          const parcel = parcelIndex.get(baOI.parcel.id);
          // uniquement utilisé dans cet écran
          (<any>parcel)['hasBeApi'] = baOI.hasBeApi;
        }
      });
    } else {
      for (const parcel of parcels) {
        (<any>parcel)['hasBeApi'] = false;
      }
    }
  }

  getBatchOrderItems(parcelIds: number[]): Observable<BeApiOrderItem[]> {
    let url = this.beApiUrl + '/orderitems/batch';
    url += '?parcels=' + parcelIds.join(',');
    return this.http.get<any>(url).pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  getOrderItemByParcel(parcelId: number): Observable<BeApiOrderItem> {
    return this.http.get<any>(this.beApiUrl + '/orderitems/parcel/' + parcelId).pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  getOrderItem(id: number): Observable<BeApiOrderItem> {
    return this.http.get<any>(this.beApiUrl + '/orderitems/' + id).pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  private handleError(error: any) {
    // FIXME
    console.error('An error occurred', error);
    return throwError(() => error.message || error);
  }
}
